/**
 * Homepage recipes carousel — 3 visible on desktop; arrows slide one recipe at a time.
 */
(function () {
  var GAP_PX = 20;

  function getPerView() {
    if (window.matchMedia('(max-width: 640px)').matches) return 1;
    return 3;
  }

  function initRecipesCarousel(root) {
    if (!root || root.dataset.sfRecipesBound === 'true') return;

    var viewport = root.querySelector('[data-sf-recipes-viewport]');
    var track = root.querySelector('[data-sf-recipes-track]');
    var prevBtn = root.querySelector('[data-sf-recipes-prev]');
    var nextBtn = root.querySelector('[data-sf-recipes-next]');
    if (!viewport || !track || !prevBtn || !nextBtn) return;

    var cards = Array.from(track.querySelectorAll('.sf-recipe-card'));
    if (cards.length === 0) return;

    root.dataset.sfRecipesBound = 'true';
    root.classList.add('sf-recipes-carousel--ready');

    var index = 0;

    function maxIndex() {
      return Math.max(0, cards.length - getPerView());
    }

    function layoutCards() {
      var perView = getPerView();
      var viewportWidth = viewport.getBoundingClientRect().width;
      if (viewportWidth < 1) return false;

      var gap = GAP_PX;
      var cardWidth = (viewportWidth - gap * (perView - 1)) / perView;

      cards.forEach(function (card) {
        card.style.flex = '0 0 ' + cardWidth + 'px';
        card.style.width = cardWidth + 'px';
        card.style.minWidth = cardWidth + 'px';
        card.style.maxWidth = cardWidth + 'px';
      });
      track.style.gap = gap + 'px';
      track.style.width = 'max-content';
      return true;
    }

    function getStep() {
      if (cards.length > 1) {
        return cards[1].offsetLeft - cards[0].offsetLeft;
      }
      return cards[0].offsetWidth + GAP_PX;
    }

    function slideTo(newIndex) {
      index = Math.max(0, Math.min(newIndex, maxIndex()));
      if (!layoutCards()) return;

      var step = getStep();
      if (step > 0) {
        track.style.transform = 'translate3d(' + -index * step + 'px, 0, 0)';
      }

      prevBtn.disabled = index <= 0;
      nextBtn.disabled = index >= maxIndex();
      prevBtn.setAttribute('aria-disabled', prevBtn.disabled ? 'true' : 'false');
      nextBtn.setAttribute('aria-disabled', nextBtn.disabled ? 'true' : 'false');
    }

    function onPrev(event) {
      event.preventDefault();
      slideTo(index - 1);
    }

    function onNext(event) {
      event.preventDefault();
      slideTo(index + 1);
    }

    prevBtn.addEventListener('click', onPrev);
    nextBtn.addEventListener('click', onNext);

    if (cards.length <= getPerView()) {
      prevBtn.hidden = true;
      nextBtn.hidden = true;
      layoutCards();
      return;
    }

    prevBtn.hidden = false;
    nextBtn.hidden = false;

    var resizeTimer;
    window.addEventListener('resize', function () {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(function () {
        slideTo(index);
      }, 100);
    });

    if (typeof ResizeObserver !== 'undefined') {
      var ro = new ResizeObserver(function () {
        slideTo(index);
      });
      ro.observe(viewport);
    }

    function start() {
      if (layoutCards()) {
        slideTo(0);
        return;
      }
      window.requestAnimationFrame(start);
    }

    if (document.readyState === 'complete') {
      start();
    } else {
      window.addEventListener('load', start, { once: true });
      start();
    }
  }

  function initAll() {
    document.querySelectorAll('[data-sf-recipes-carousel]').forEach(initRecipesCarousel);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (event) {
    var carousel = event.target.querySelector('[data-sf-recipes-carousel]');
    if (carousel) {
      delete carousel.dataset.sfRecipesBound;
      carousel.classList.remove('sf-recipes-carousel--ready');
      initRecipesCarousel(carousel);
    }
  });
})();
